import * as ToastPrimitive from "@radix-ui/react-toast";
import { CheckCircle2, AlertTriangle, Info, XCircle, X } from "lucide-react";
import { useAppStore } from "@/stores/app.store";
import { cn } from "@/lib/cn";

const ICON = {
  success: CheckCircle2,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
} as const;

const TONE = {
  success: "text-success",
  error: "text-danger",
  warning: "text-warning",
  info: "text-accent",
} as const;

export function Toaster() {
  const { toasts, removeToast } = useAppStore();
  return (
    <ToastPrimitive.Provider swipeDirection="right">
      {toasts.map((t) => {
        const Icon = ICON[t.type];
        return (
          <ToastPrimitive.Root
            key={t.id}
            onOpenChange={(open) => !open && removeToast(t.id)}
            className="card shadow-modal p-3.5 pr-9 flex gap-3 items-start relative animate-slide-up"
          >
            <Icon
              className={cn("w-4 h-4 mt-0.5 flex-shrink-0", TONE[t.type])}
            />
            <div className="min-w-0">
              <ToastPrimitive.Title className="text-sm font-medium text-text-primary">
                {t.title}
              </ToastPrimitive.Title>
              {t.description && (
                <ToastPrimitive.Description className="text-xs text-text-secondary mt-0.5">
                  {t.description}
                </ToastPrimitive.Description>
              )}
            </div>
            <ToastPrimitive.Close className="absolute top-2.5 right-2.5 text-text-tertiary hover:text-text-primary">
              <X className="w-3.5 h-3.5" />
            </ToastPrimitive.Close>
          </ToastPrimitive.Root>
        );
      })}
      <ToastPrimitive.Viewport className="fixed bottom-4 right-4 flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)] z-50 outline-none" />
    </ToastPrimitive.Provider>
  );
}
